import { alpha } from '@mui/material/styles';
import { IconButton, Typography, Button, styled } from '../../base';

export const ShareButton = styled(IconButton)(({ theme }) => ({
    width: 72,
    height: 72,
    marginInlineEnd: theme.spacing(1),
    backgroundColor: alpha(theme.palette.grey[600], 0.04),
    '&:hover': {
        backgroundColor: theme.palette.primary.light,
        '& svg': {
            color: theme.palette.primary.main,
        },
    },
}));

export const CopyButton = styled(IconButton)(({ theme }) => ({
    padding: theme.spacing(1),
    color: theme.palette.warning.main,
}));

export const DefaultLinkContainer = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.grey[100],
    borderRadius: 16,
    padding: theme.spacing(1, 2),
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
}));

export const TrackableLinkItem = styled('div')({
    display: 'flex',
    alignItems: 'center',
    padding: '12px 0',
});

export const LinkText = styled(Typography)({
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

export const AddTrackableButton = styled(Button)(({ theme }) => ({
    color: theme.palette.warning.main,
    borderColor: theme.palette.warning.main,
    borderStyle: 'dashed',
    borderWidth: 1,
    borderRadius: 37,
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
    width: '195px',
    '&:hover': {
        borderColor: theme.palette.warning.dark,
        backgroundColor: 'transparent',
    },
}));

export const BottomSection = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.grey[100],
    marginTop: theme.spacing(2),
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
}));

export const ActionButton = styled(Button)(({ theme }) => ({
    borderRadius: 20,
    padding: theme.spacing(1, 4),
}));

export const ButtonsWrap = styled('div')(({}) => ({
    display: 'flex',
    justifyContent: 'center',
}));
